export default __webpack_public_path__ + "static/media/010-audio guide.ab45bb1c.svg";